import React, { Component } from 'react';
import GlobalStoreService from '../../services/global-store.service'
import UtilService from '../../services/util.service'

const PopUp = (popup_data,popupVisible,height,width) => {
    
    const isApp = (GlobalStoreService.get("APP_CONTEXT")) ? true : false;
    return (

        <div className="popup_class home">
            <div
                className="overlay" style={{height: isApp?  '100vh' : 'calc(100vh - 56px)',
                    marginTop: (isApp)? 0 :'56px',
                    visibility:(!popupVisible)? 'hidden' : 'visible'}}>
                <div className = {"subscribe " + (UtilService.getOS() === "Windows" ? "custom-scrollbar" : "")} style={{overflow:'auto',height:height?height:'',maxHeight:height?`calc(100% - 28px)`:'330px',width:width?width:'280px'}}>
                {popup_data}
                </div>
            </div>


        </div>

);
}

export default PopUp;


// WEBPACK FOOTER //
// ./src/components/common-components/popup.js